import { baseApi } from 'segments/api/baseApi';

import { adapteImageList } from '../utils/adapter';

import type { CreateImageParams, GetImageListParams, ImageList } from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getImagesList: builder.query<ImageList, GetImageListParams>({
      query: (params) => ({
        url: '/admin/images/list',
        method: 'GET',
        params: {
          ...params,
          asceding: true
        }
      }),
      transformResponse: adapteImageList,
      providesTags: ['imageList'],
      keepUnusedDataFor: 1,
    }),

    createImage: builder.mutation<unknown, CreateImageParams>({
      query: ({ body }) => ({
        url: '/admin/images/upload',
        method: 'POST',
        body: body
      }),
      invalidatesTags: ['imageList'],
    }),

    deleteImage: builder.mutation<unknown, number>({
      query: (id: number) => ({
        url: `/admin/images/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['imageList'],
    }),
  }),
});

export const {
  useCreateImageMutation,
  useDeleteImageMutation,
  useGetImagesListQuery
} = api;
